export default from './TetherComponent';
